import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hoqbehecunvgbkxwvdib.supabase.co';
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhvcWJlaGVjdW52Z2JreHd2ZGliIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYyNjc5NzgsImV4cCI6MjA5MTg0Mzk3OH0.ElzsHflMTr6Hzja0PSFwCHdhi0sH6Ve7yiBS8Ui2hGI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
